import { t } from 'i18next';
import { intersection, isNil } from 'lodash';
import { v4 as uuid } from 'uuid';
import * as Yup from 'yup';
import { FormServFieldType, McrContactType } from '../../../../shared/types';
import { getInputValue } from '../../../utils';

export const getAllFileColumnNamesFromJson = (data: any[]): string[] => {
  // since we have defval: null, all the columns will be available
  return Object.keys(data?.[0] || {});
  // const allColumns = {};
  // if (data.length > 0) {
  //   data.forEach((row) => {
  //     Object.keys(row).forEach((key) => {
  //       allColumns[key] = true;
  //     });
  //   });
  // }
  // return Object.keys(allColumns);
};

export const getJsonFromContacts = (
  fields: FormServFieldType[],
  contactListIds: string[],
  excelData: any[],
  mappings: any,
) => {
  const mappingKeys = Object.keys(mappings);
  if (!mappingKeys || mappingKeys.length === 0) return [];
  const allFields = {};
  const customFieldsToPopulate = {};
  const fieldsToPopulate = {};
  fields.forEach((field) => {
    allFields[field.name] = field;
    if (field.default_value) {
      const value = getInputValue(field.type, field.default_value);
      if (field.custom) {
        customFieldsToPopulate[field.name] = value;
      } else {
        fieldsToPopulate[field.name] = value;
      }
    }
  });
  return excelData.map((data: McrContactType) => {
    const contact: any = { ...fieldsToPopulate };
    if (contactListIds && contactListIds.length > 0)
      contact['fields.list_ids'] = `${contactListIds}`;
    Object.keys(customFieldsToPopulate).forEach((key) => {
      contact[`fields.${key}`] = `${customFieldsToPopulate[key]}`;
    });
    mappingKeys.forEach((key) => {
      if (!isNil(mappings[key]) && !isNil(data[mappings[key]])) {
        if (allFields[key].custom) {
          contact[`fields.${key}`] = `${data[mappings[key]]}`;
        } else {
          contact[key] = `${data[mappings[key]]}`;
        }
      }
      contact.external_id = uuid();
    });
    return contact;
  });
};

export const schema = (
  fields: FormServFieldType[],
  additionalSchema?: any,
): Yup.AnyObjectSchema => {
  const mandatoryFields = fields.filter(
    (field) => field.required && field.visible,
  );
  const contactFieldsSchema = {};
  mandatoryFields.forEach((mandatoryField) => {
    contactFieldsSchema[mandatoryField.name] = Yup.string()
      .typeError(`${t('forms.err_msg.required_field')}`)
      .required(`${t('forms.err_msg.required_field')}`);
  });
  return Yup.object({
    addToLists: Yup.array().of(Yup.string()),
    fileMetaData: Yup.object(),
    importContacts: Yup.object().when('fileMetaData', {
      is: (fileMetaData) => Boolean(fileMetaData?.name),
      then: Yup.object(contactFieldsSchema).required(),
      otherwise: Yup.object().notRequired().nullable(),
    }),
    ...additionalSchema,
  }).required();
};

export const getAutoMapping = ({
  fields,
  fileColumns,
}: {
  fields: FormServFieldType[];
  fileColumns: string[];
}) => {
  const mapping = {};
  const completedFileColumns: string[] = [];
  fields.forEach((field) => {
    fileColumns.forEach((fileColumn) => {
      if (field.name === fileColumn) {
        mapping[field.name] = fileColumn;
        completedFileColumns.push(fileColumn);
        return;
      }
      if (completedFileColumns.includes(fileColumn)) return;
      const fileColumnName = fileColumn.toLowerCase().replaceAll('_', ' ');
      const fieldName = (field?.label || '').toLowerCase().replaceAll('_', ' ');
      if (
        fileColumnName.indexOf(fieldName) > 0 ||
        fileColumnName === fieldName
      ) {
        mapping[field.name] = fileColumn;
        completedFileColumns.push(fileColumn);
        return;
      }
      if (
        intersection(fileColumnName.split(''), fieldName.split(' ')).length > 0
      ) {
        mapping[field.name] = fileColumn;
        completedFileColumns.push(fileColumn);
        return;
      }
    });
  });
  return mapping;
};
